export const IOS_APP_URL = "https://apps.apple.com/us/app/ace-pdg/id6738878262";
export const ANDROID_APP_URL =
  "https://play.google.com/store/apps/details?id=com.acepdgapp&hl=en";

export const IOS_SJT_APP_URL =
  "https://apps.apple.com/us/app/ace-sjt-air-force/id6740575751";
export const ANDROID_SJT_APP_URL =
  "https://play.google.com/store/apps/details?id=com.acesjt";
